module.exports = __webpack_public_path__ + "img/banner_home-o.71af006b.jpg";